const dewormingTypes = [
    { value: 'internal', 
        label: { 
            en: 'Internal', 
            es: 'Interno' } },
    { value: 'external', 
        label: { 
            en: 'External', 
            es: 'Externo' } },
    { value: 'both', 
        label: { 
            en: 'Both', 
            es: 'Ambos' } },
];

export default dewormingTypes;